import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { guid } from '@/mixins/guid';

export default Vue.component('read-submission', {
  template: require('./template.html'),
  name: 'read-submission',
  mixins: [guid],
  computed: {
    ...mapGetters(['currentSite']),
    hiddenFields() {
      return ['_id', 'pageId', 'formId', 'siteId'];
    },
  },
  props: ['read-modal', 'activeSubmission'],
  data() {
    return {
      loading: false,
      confirmDelSub: false,
    };
  },
  watch: {
    readModal(o) {
      if (!o) {
        this.confirmDelSub = false;
      }
    },
  },
  methods: {
    async deleteFormSubmission() {
      this.loading = true;
      const notif = {
        id: this.guid(),
        type: 'success',
        message: 'Successfully deleted form submission!',
      };
      try {
        const response = await this._SEND([{
          name: 'deleteFormSubmission',
          payload: {
            site: this.currentSite._id,
            submission: this.activeSubmission,
          },
        }]);
        this.$log.debug('Successfully deleted form submission: ', response);

        this.closeModal();
        // delete submission from state
        const fn = () => {
          const i = _.findIndex(
            this.currentSite.formSubmissions, s => s._id === this.activeSubmission._id);
          if (i !== -1) {
            this.currentSite.formSubmissions.splice(i, 1);
          }
        };
        this.$store.dispatch('runStateFn', { fn });
      } catch (e) {
        notif.type = 'error';
        notif.message = e.message || e;
        this.$log.error(e.message || e);
        await this._reportError({
          error: e,
          fn: 'deleteFormSubmission',
        });
      } finally {
        this.loading = false;
        this.$store.dispatch('addNotification', notif);
      }
    },
    closeModal() {
      this.$emit('toggle-modal', null, 'child');
    },
    title(name) {
      return _.startCase(name);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/websites/edit-site/forms/read-submission/index.js